import { ExperienceSchedule } from './experience-schedule';
import { BehaviorSubject, Subscriber, merge, Observable } from 'rxjs';
import { EventInput } from '@fullcalendar/core';
import { ExperienceScheduleService } from '../experience-schedule.service';
import moment from 'moment';
import { Experience } from 'src/app/shared/models/experience.model';

export type DayStatus = 'BLOCKED' | 'OPEN' | 'PARTIALLY_BLOCKED';

export class ExperienceAggregator {

  private schedules = [] as ExperienceSchedule[];
  private changeDetector: Observable<any>;
  events = new BehaviorSubject<EventInput[]>([]);
  experiencesFilter = new BehaviorSubject<number>(null);

  constructor(experiences: Array<Experience>, private service: ExperienceScheduleService) {
    this.init(experiences);
  }

  init(experiences: Array<Experience>) {
    this.schedules = [];
    this.changeDetector = null;
    this.events.next([]);
    for (const experience of experiences) {
      const s = new ExperienceSchedule(experience, this.service);
      this.schedules.push(s);
    }
    this.changeDetector = merge(
      ...this.schedules.map(sch => sch.formattedAvailability),
      this.experiencesFilter
    );

    this.changeDetector.subscribe((v) => {
      this.collectEvents();
    });
  }

  collectEvents() {
    const events = [];
    let schedules = this.schedules;
    if (this.experiencesFilter.value) {
      schedules = schedules.filter(sch => {
        return sch.experience.id === this.experiencesFilter.value;
      });
    }
    for (const sch of schedules) {
      events.push(...sch.formattedAvailability.value);
    }
    this.events.next(events);
  }

  getEventsAtDate(dateLike, withBlocked = false) {
    return this.events.value.filter(ev => {
      return (
        moment(dateLike).isSameOrAfter(ev.start, 'day') &&
        moment(dateLike).isSameOrBefore(ev.end, 'day')
      ) && (withBlocked ? true : ev.backgroundColor !== 'red');
    });
  }

  checkDayStatus(dateLike): DayStatus {
    const allDayEvents = this.getEventsAtDate(dateLike, true);
    const blockedEvents = allDayEvents.filter(e => e.backgroundColor === 'red');
    let status: DayStatus;
    if (blockedEvents.length === 0) {
      status =  'OPEN';
    } else if (allDayEvents.length === blockedEvents.length) {
      status =  'BLOCKED';
    } else {
      status =  'PARTIALLY_BLOCKED';
    }
    return status;
  }

  blockDay(dateLike, extras) {
    let schedules = this.schedules;
    if (this.experiencesFilter.value) {
      schedules = this.schedules.filter(sch => {
        return sch.experience.id === this.experiencesFilter.value;
      });
    }

    for (const sch of schedules) {
      sch.blockDay(dateLike, extras);
    }
  }

  unblockDay(dateLike, extras?) {
    let schedules = this.schedules;
    if (this.experiencesFilter.value) {
      schedules = this.schedules.filter(sch => {
        return sch.experience.id === this.experiencesFilter.value;
      });
    }

    for (const sch of schedules) {
      sch.unblockDay(dateLike);
    }
  }

}
